const currentState = {
  budgets: {
    data: null,
    error: null,
  },
  budgetItems: {
    data: null,
    error: null,
  },
  evaluationStatuses: {
    data: null,
    error: null,
  },
  evaluationYearHistory: {
    data: null,
    error: null,
  },
  companyGroups: {
    data: null,
    error: null,
  },
};

const reducer = (state = currentState, action) => {
  switch (action.type) {
    case "INSTANTIATE_BUDGETS":
      const budgets = { ...state.budgets };

      if (null !== action.payload.budgets)
        budgets.data = action.payload.budgets;

      budgets.error = action.payload.error ?? false;

      return {
        ...state,
        budgets: budgets,
      };

    case "INSTANTIATE_BUDGET_ITEMS":
      const budgetItems = { ...state.budgetItems };

      if (null !== action.payload.budgetItems)
        budgetItems.data = action.payload.budgetItems;

      budgetItems.error = action.payload.error ?? false;

      return {
        ...state,
        budgets: budgetItems,
      };
    default:
      return state;
  }
};

export default reducer;
